"use strict";

module.exports = function getrandmax() {
  //  discuss at: http://locutus.io/php/getrandmax/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: getrandmax()
  //   returns 1: 2147483647

  return 2147483647;
};
//# sourceMappingURL=getrandmax.js.map


//////////////////
// WEBPACK FOOTER
// ./~/locutus/php/math/getrandmax.js
// module id = aen+
// module chunks = 0